import React from 'react';
import { Helmet } from 'react-helmet';

import { Outlet } from 'react-router-dom';

export const ConversaoBeneficiosPage = () => {
  return (
    <>
      <Helmet>
        <title>Forluz - Conversão de Benefícios</title>
      </Helmet>
      <h1 className="fw-bold page-title mb-32 mb-md-5">
        Conversão de Benefícios
      </h1>
      <Outlet />
    </>
  );
};
